// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared modal body: the container, field, footer and button vocabulary every
 * ModalShell-based dialog uses.
 *
 * The class names here are the ones the token-based modals settled on
 * (.fieldLabel / .footer / .primaryBtn / .ghostBtn), so a modal can be read
 * without first working out which of three vocabularies it happens to use.
 * \`.label\`, \`.buttonRow\`, \`.primaryButton\` and \`.secondaryButton\` are kept as
 * aliases for existing callers.
 *
 * Colours, type and geometry come from ../styles/curioTokens.css.
 */

.fzumVc23VYOI4VLDBLeA {
  padding: 24px 28px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
  flex: 1;
  font-family: var(--curio-font-family);
  color: var(--curio-text-primary);
}

.VM7XG3WG4gvLTxk5th0u {
  margin: 0 32px 0 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--curio-text-primary);
}

.wBJSa14ZSJcBLeJ8SJ5K {
  margin: 0;
  font-size: var(--curio-font-size-md);
  color: var(--curio-text-secondary);
  line-height: 1.4;
}

.vqi2QPHXSeFsXXqt5AqR {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.rh9feFsSHQ4qpzSFvxDf,
._fXgMPZLV6yva_NJQwlV {
  display: block;
  font-size: var(--curio-font-size-xs);
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--curio-text-muted);
}

.GiGvNiIx8EEE2svcKyKQ,
.AQwtvnW2Po0umtWtT8Q0,
.EoOwjWDQu8ERof9nNCgt {
  padding: 9px 12px;
  border: 1px solid var(--curio-border-strong);
  border-radius: var(--curio-radius-md);
  background: var(--curio-card-bg);
  font: inherit;
  font-size: var(--curio-font-size-md);
  color: var(--curio-text-primary);
  outline: none;
  width: 100%;
  box-sizing: border-box;
}

.GiGvNiIx8EEE2svcKyKQ:focus,
.AQwtvnW2Po0umtWtT8Q0:focus,
.EoOwjWDQu8ERof9nNCgt:focus {
  border-color: var(--curio-top-bar-bg);
}

.EoOwjWDQu8ERof9nNCgt {
  resize: vertical;
  min-height: 80px;
}

.DzTUkPvOdpppyEDZSDxr,
.PJNnDdrU5x8UB6wvSKql {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
}

/* One dark primary across every modal, and one hover for it: a darken, not the
   orange flip two of these used to do. */
.vthzfUl6A8bmtgsgAgmA,
.f6PYxWPFzeKxkZ7w31p_ {
  padding: 0 20px;
  height: var(--curio-input-height);
  border: none;
  border-radius: var(--curio-radius-md);
  background: var(--curio-top-bar-bg);
  color: var(--curio-text-on-dark);
  font: inherit;
  font-size: var(--curio-font-size-lg);
  font-weight: 600;
  cursor: pointer;
}

.vthzfUl6A8bmtgsgAgmA:hover:not(:disabled),
.f6PYxWPFzeKxkZ7w31p_:hover:not(:disabled) {
  background: var(--curio-top-bar-bg-hover);
}

.wk8SKBvSfAgkHefCA4Z1,
._0_WKsm5O8_dPob2BswR {
  padding: 0 16px;
  height: var(--curio-input-height);
  border: 1px solid var(--curio-border-strong);
  border-radius: var(--curio-radius-md);
  background: var(--curio-card-bg);
  color: var(--curio-text-primary);
  font: inherit;
  font-size: var(--curio-font-size-lg);
  font-weight: 500;
  cursor: pointer;
}

.wk8SKBvSfAgkHefCA4Z1:hover:not(:disabled),
._0_WKsm5O8_dPob2BswR:hover:not(:disabled) {
  background: var(--curio-page-bg);
}

.vthzfUl6A8bmtgsgAgmA:disabled,
.f6PYxWPFzeKxkZ7w31p_:disabled,
.wk8SKBvSfAgkHefCA4Z1:disabled,
._0_WKsm5O8_dPob2BswR:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.f1bMpWNmYG0R35vALNQb {
  font-size: var(--curio-font-size-sm);
  color: var(--curio-text-muted);
  line-height: 1.45;
}

.ce0GuddMDv61wRa7905Q {
  color: var(--curio-danger-text);
  font-size: var(--curio-font-size-md);
  margin: 4px 0 0;
}

.lA4vV7rHueKXYjFTN6vu {
  color: var(--curio-success-text);
  font-size: var(--curio-font-size-md);
  margin: 4px 0 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/modal-content.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;EAUE;;AAEF;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,OAAO;EACP,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,cAAc;EACd,oCAAoC;EACpC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;;;EAGE,iBAAiB;EACjB,4CAA4C;EAC5C,qCAAqC;EACrC,gCAAgC;EAChC,aAAa;EACb,oCAAoC;EACpC,gCAAgC;EAChC,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,eAAe;AACjB;;AAEA;yCACyC;AACzC;;EAEE,eAAe;EACf,iCAAiC;EACjC,YAAY;EACZ,qCAAqC;EACrC,mCAAmC;EACnC,gCAAgC;EAChC,aAAa;EACb,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;;EAEE,eAAe;EACf,iCAAiC;EACjC,4CAA4C;EAC5C,qCAAqC;EACrC,gCAAgC;EAChC,gCAAgC;EAChC,aAAa;EACb,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,eAAe;AACjB","sourcesContent":["/* Shared modal body: the container, field, footer and button vocabulary every\n * ModalShell-based dialog uses.\n *\n * The class names here are the ones the token-based modals settled on\n * (.fieldLabel / .footer / .primaryBtn / .ghostBtn), so a modal can be read\n * without first working out which of three vocabularies it happens to use.\n * `.label`, `.buttonRow`, `.primaryButton` and `.secondaryButton` are kept as\n * aliases for existing callers.\n *\n * Colours, type and geometry come from ../styles/curioTokens.css.\n */\n\n.content {\n  padding: 24px 28px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  overflow-y: auto;\n  flex: 1;\n  font-family: var(--curio-font-family);\n  color: var(--curio-text-primary);\n}\n\n.title {\n  margin: 0 32px 0 0;\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: var(--curio-text-primary);\n}\n\n.subtitle {\n  margin: 0;\n  font-size: var(--curio-font-size-md);\n  color: var(--curio-text-secondary);\n  line-height: 1.4;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.fieldLabel,\n.label {\n  display: block;\n  font-size: var(--curio-font-size-xs);\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--curio-text-muted);\n}\n\n.input,\n.select,\n.textarea {\n  padding: 9px 12px;\n  border: 1px solid var(--curio-border-strong);\n  border-radius: var(--curio-radius-md);\n  background: var(--curio-card-bg);\n  font: inherit;\n  font-size: var(--curio-font-size-md);\n  color: var(--curio-text-primary);\n  outline: none;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.input:focus,\n.select:focus,\n.textarea:focus {\n  border-color: var(--curio-top-bar-bg);\n}\n\n.textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.footer,\n.buttonRow {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n/* One dark primary across every modal, and one hover for it: a darken, not the\n   orange flip two of these used to do. */\n.primaryBtn,\n.primaryButton {\n  padding: 0 20px;\n  height: var(--curio-input-height);\n  border: none;\n  border-radius: var(--curio-radius-md);\n  background: var(--curio-top-bar-bg);\n  color: var(--curio-text-on-dark);\n  font: inherit;\n  font-size: var(--curio-font-size-lg);\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.primaryBtn:hover:not(:disabled),\n.primaryButton:hover:not(:disabled) {\n  background: var(--curio-top-bar-bg-hover);\n}\n\n.ghostBtn,\n.secondaryButton {\n  padding: 0 16px;\n  height: var(--curio-input-height);\n  border: 1px solid var(--curio-border-strong);\n  border-radius: var(--curio-radius-md);\n  background: var(--curio-card-bg);\n  color: var(--curio-text-primary);\n  font: inherit;\n  font-size: var(--curio-font-size-lg);\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.ghostBtn:hover:not(:disabled),\n.secondaryButton:hover:not(:disabled) {\n  background: var(--curio-page-bg);\n}\n\n.primaryBtn:disabled,\n.primaryButton:disabled,\n.ghostBtn:disabled,\n.secondaryButton:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.hint {\n  font-size: var(--curio-font-size-sm);\n  color: var(--curio-text-muted);\n  line-height: 1.45;\n}\n\n.error {\n  color: var(--curio-danger-text);\n  font-size: var(--curio-font-size-md);\n  margin: 4px 0 0;\n}\n\n.success {\n  color: var(--curio-success-text);\n  font-size: var(--curio-font-size-md);\n  margin: 4px 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `fzumVc23VYOI4VLDBLeA`,
	"title": `VM7XG3WG4gvLTxk5th0u`,
	"subtitle": `wBJSa14ZSJcBLeJ8SJ5K`,
	"field": `vqi2QPHXSeFsXXqt5AqR`,
	"fieldLabel": `rh9feFsSHQ4qpzSFvxDf`,
	"label": `_fXgMPZLV6yva_NJQwlV`,
	"input": `GiGvNiIx8EEE2svcKyKQ`,
	"select": `AQwtvnW2Po0umtWtT8Q0`,
	"textarea": `EoOwjWDQu8ERof9nNCgt`,
	"footer": `DzTUkPvOdpppyEDZSDxr`,
	"buttonRow": `PJNnDdrU5x8UB6wvSKql`,
	"primaryBtn": `vthzfUl6A8bmtgsgAgmA`,
	"primaryButton": `f6PYxWPFzeKxkZ7w31p_`,
	"ghostBtn": `wk8SKBvSfAgkHefCA4Z1`,
	"secondaryButton": `_0_WKsm5O8_dPob2BswR`,
	"hint": `f1bMpWNmYG0R35vALNQb`,
	"error": `ce0GuddMDv61wRa7905Q`,
	"success": `lA4vV7rHueKXYjFTN6vu`
};
export default ___CSS_LOADER_EXPORT___;
